import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";
import {ResourcesRequestsService} from "../../services/resources-requests.service";

export class ResourceMultiSelectListComponent implements IController {
  selectedIds: any;
  optionIds: any;
  excludeIds: any;
  onChange: Function;

  public resources:any;
  public loading:boolean = false;
  private queryString: any;
  private selectedKeys: any;
  private excludeKeys: any;

  /* @ngInject */
  constructor(private $log, private resourcesRequestsService:ResourcesRequestsService) {
  }

  $onInit() {
    this.loading = true;
    this.resourcesRequestsService.getResources(undefined,undefined,undefined,undefined,undefined,[])
      .then((resources) => {
        this.resources = resources;
      })
      .finally(()=>{
        this.loading = false;
      })

  }

  $onChanges(changes) {
    if (changes.selectedIds) {
      this.selectedKeys = [];
      _.forEach(this.selectedIds, (id) => {
        this.selectedKeys[id] = true;
      })
    }
    if (changes.excludeIds) {
      this.excludeKeys = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludeKeys[id] = true;
      })
    }
  }

  onToggle(resourceId, isSelected) {
    this.onChange({
      resourceIds: isSelected ? _.concat(this.selectedIds || [], [resourceId]) :
        _.filter(this.selectedIds,(id) => {
          return id !== resourceId;
        })
    });
  }

  submitQuery(query) {
    this.queryString = query;
  }

}

angular
  .module('bringoz.admin.resources')
  .component('resourceMultiSelectList', {
    bindings: {
      selectedIds: '<',
      optionIds: '<?',
      excludeIds: '<?',
      onChange: '&'
    },
    template: require('./resource-multi-select-list.html').default,
    controller: ResourceMultiSelectListComponent
  });
